<template>
    <div class="row justify-content-center">
        <div class="col-md-5">
            <div class="card">

                <div class="card-body">
                    <img :src="'images/logo-horizontal-white.png'" class="w-100 py-5" />

                    <h3 class="text-center text-white pb-2">Dealer Portal</h3>
                    <form
                        method="post"
                        autocomplete="off"
                        enctype="multipart/form-data"
                        @submit.prevent="handleSubmit"
                    >

                        <div class="form-group mt-2 mb-4">
                            <label class="text-white">Log In</label>
                            <input 
                                type="text" 
                                v-model="email" 
                                name="email" autofocus placeholder="Email Address" 
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        v$.email.$error,
                                }">
                        </div>

                        <div class="form-group my-4">
                            <label class="text-white">Password</label>
                            <input 
                                type="password" 
                                v-model="password" 
                                name="password" autofocus placeholder="Password" 
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        v$.password.$error,
                                }">
                        </div>

                        <div class="form-group my-2">
                            <div class="cf-turnstile" data-theme="light" :data-sitekey="sitekey"></div>
                        </div>

                        <div class="form-group my-4">
                            <div class="float-start">
                                <a href="/register" class="btn btn-link text-white p-0">Register</a>
                                <span class="text-white">/</span>
                                <a class="btn btn-link text-white p-0" href="/forgot-password">
                                    Forgot Your Password?
                                </a>
                            </div>

                            <button type="submit" class="btn btn-login text-uppercase float-end">
                                Login
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapGetters } from "vuex";

import { useVuelidate } from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    requiredIf,
} from "@vuelidate/validators";

export default {
    props: ["type","sitekey","secretkey"],
    emits: [],
    components: {},
    setup() {
        const store = useStore();

        onMounted(() => {});

        return {
            store,
        };
    },
    data() {
        return {
            csrf: document.head.querySelector('meta[name="csrf-token"]')
                .content,
            v$: useVuelidate(),
            name: null,
            password: null,
            submitted: false,
            showEmailExist: false,

        };
    },
    computed: {},
    validations() {
        return {
            email: { required, email },
            password: {
                required,
            },
        };
    },
    mounted() {
        console.log(this.csrf);
        console.log(this.site_key);
        console.log(this.sitekey);
    },
    methods: {
        handleSubmit(e) {
            this.submitted = true;

            this.v$.$validate();
            if (!this.v$.$error) {
                axios
                    .post("/api/login", {
                        email: this.email,
                        password: this.password,
                    })
                    .then((response) => {
                        console.log('response',response)

                        if (response.data.status == 'success') {
                            this.$router.push('/');
                        }
                    })
                    .catch((error) => {
                        console.log('error',error)
                    });
            } else {
                // alert('Form failed validation')
            }
        },
    },
};
</script>
